/** Words and phrases used by more than one screen. Keep keys grouped by prefix. */
export const enCommon = {
  'when.format': '{date} at {time}',
  'lang.label': 'Language',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.save': 'Save',
  'common.delete': 'Delete',
  'common.add': 'Add',
  'common.remove': 'Remove',
  'common.done': 'Done',
  'common.back': 'Back',
  'common.loading': 'Loading…',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.none': 'None',
  'common.guest': 'Guest',
  'common.guests_one': '{n} guest',
  'common.guests_other': '{n} guests',
  'common.ppl': '{n} ppl',
} as const;
